import provincesGeoJSON from '../variables/phil_geo.json';

import { isMobileOS, isRaspbian, getOS } from './detectOS';

let cachedLocation = null;
let cachedProvinceName = null;

/**
 * Initialize user's geolocation once (async).
 * Falls back to IP-based location if GPS/Wi-Fi location fails.
 */
export async function initUserLocation() {
  return new Promise((resolve) => {
    if (!navigator.geolocation) {
      console.warn('Geolocation not supported by this browser.');
      return getIpFallback(resolve);
    }

    navigator.geolocation.getCurrentPosition(
      async (pos) => {
        const { latitude, longitude } = pos.coords;
        cachedLocation = [longitude, latitude];
        cachedProvinceName = detectProvinceFromCoords(cachedLocation);
        resolve(cachedProvinceName);
      },
      async (err) => {
        switch (err.code) {
          case err.PERMISSION_DENIED:
            console.warn('User denied the request for Geolocation.');
            break;
          case err.POSITION_UNAVAILABLE:
            console.warn('Position unavailable — using IP fallback.');
            break;
          case err.TIMEOUT:
            console.warn('Geolocation timed out — using IP fallback.');
            break;
          default:
            console.warn('Unknown geolocation error:', err);
        }
        await getIpFallback(resolve);
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0
      }
    );
  });
}

/**
 * Fallback method — fetch approximate location via public IP API.
 */
async function getIpFallback(resolve) {
  try {
    const res = await fetch('https://ipapi.co/json/');
    const data = await res.json();
    cachedProvinceName = data.region || data.region_name || null;
    cachedLocation = data.longitude && data.latitude ? [data.longitude, data.latitude] : null;

    if (cachedProvinceName) {
      console.log(`✅ IP fallback resolved province: ${cachedProvinceName}`);
      resolve(cachedProvinceName);
    } else {
      console.warn('IP-based fallback failed to determine province.');
      resolve(null);
    }
  } catch (e) {
    console.warn('Error fetching IP-based location:', e);
    resolve(null);
  }
}

export function getStoredEnvironment() {
  const raw = localStorage.getItem('user_env');
  return raw ? JSON.parse(raw) : null;
}

/**
 * Checks if the user is within the target province (sync after init).
 */
export function checkIfUserInLocation(targetProvince) {
  if (isRaspbian()) {
		return true;
	}

  const env = getStoredEnvironment();
  console.log(env);
  if (!env?.province) return false;

  return env.province.toLowerCase() === targetProvince?.toLowerCase();
  
}

/**
 * Detects province name from coordinates using GeoJSON.
 */
function detectProvinceFromCoords([lon, lat]) {
  const feature = provincesGeoJSON.features.find((f) =>
    pointInPolygon([lon, lat], f.geometry.coordinates)
  );
  return feature ? feature.properties.NAME_1 : null;
}

/**
 * Determines if a point is inside a GeoJSON polygon/multipolygon.
 */
function pointInPolygon(point, polygonCoords) {
  const [x, y] = point;
  const polygons = polygonCoords.length && Array.isArray(polygonCoords[0][0][0])
    ? polygonCoords
    : [polygonCoords];

  for (const polygon of polygons) {
    let inside = false;
    const coords = polygon[0];
    for (let i = 0, j = coords.length - 1; i < coords.length; j = i++) {
      const [xi, yi] = coords[i];
      const [xj, yj] = coords[j];
      const intersect =
        yi > y !== yj > y &&
        x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;
      if (intersect) inside = !inside;
    }
    if (inside) return true;
  }
  return false;
}

function detectProvince(lat, lng) {
	for (const feature of provincesGeoJSON.features) {
		const name = feature.properties.NAME_1;
		const [polygon] = feature.geometry.coordinates;

    if(name === 'MetropolitanManila'){
      console.log(name);
      console.log(polygon);
      console.log(lat + ',' + lng);
    }

		let inside = false;
		for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
			const [xi, yi] = polygon[i];
			const [xj, yj] = polygon[j];

			const intersect =
				yi > lng !== yj > lng &&
				lat < ((xj - xi) * (lng - yi)) / (yj - yi) + xi;

			if (intersect) inside = !inside;
		}

		if (inside) return name;
	}
	return null;
}

export async function detectProvinceFromIP() {
	try {
		const res = await fetch('https://ipapi.co/json/');
		const data = await res.json();

		return {
			province: data.region || null,
			city: data.city || null,
			source: 'IP',
		};
	} catch {
		return null;
	}
}

export async function detectUserEnvironment() {
	const result = {
		os: getOS(),
		province: null,
		city: null,
		source: null,
	};

	// 1️⃣ Try GPS first
	if (navigator.geolocation) {
		try {
			const position = await new Promise((resolve, reject) =>
				navigator.geolocation.getCurrentPosition(resolve, reject, {
					enableHighAccuracy: true,
					timeout: 10000,
				})
			);

			const { latitude, longitude } = position.coords;
			//const province = detectProvince(latitude, longitude);
      const province = detectProvinceFromCoords([longitude, latitude]);

			if (province) {
				result.province = province;
				result.source = 'GPS';
				return result;
			}
		} catch {
			// fall through to IP
		}
	}

	// 2️⃣ IP fallback
	const ipData = await detectProvinceFromIP();
	if (ipData) {
		result.province = ipData.province;
		result.city = ipData.city;
		result.source = 'IP';
	}

	return result;
}